import { render, staticRenderFns } from "./MediasMp.vue?vue&type=template&id=52ac510c&scoped=true&"
import script from "./MediasMp.vue?vue&type=script&lang=js&"
export * from "./MediasMp.vue?vue&type=script&lang=js&"
import style0 from "./MediasMp.vue?vue&type=style&index=0&id=52ac510c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac510c",
  null
  
)

export default component.exports